import { ReservationRequestStatus } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import * as Model from "../../../model";

export const RESERVATION_TYPE_OPTIONS: Array<FormOptionType> = [
	{
		id: Model.Constants.ReservationTypeForSearchReservationRequestList.monthCount,
		label: "直近3ヶ月の新着リクエスト",
		value: Model.Constants.ReservationTypeForSearchReservationRequestList.monthCount,
	},
	{
		id: Model.Constants.ReservationTypeForSearchReservationRequestList.cInDate,
		label: "チェックイン日",
		value: Model.Constants.ReservationTypeForSearchReservationRequestList.cInDate,
	},
	{
		id: Model.Constants.ReservationTypeForSearchReservationRequestList.updatedDate,
		label: "リクエスト日/更新日",
		value: Model.Constants.ReservationTypeForSearchReservationRequestList.updatedDate,
	},
];

export const RESERVATION_REQUEST_STATUS_OPTIONS: Array<FormOptionType> = [
	{
		id: ReservationRequestStatus.Unnoticed,
		label: "新着リクエスト",
		value: ReservationRequestStatus.Unnoticed,
	},
	{
		id: ReservationRequestStatus.Confirmed,
		label: "承認",
		value: ReservationRequestStatus.Confirmed,
	},
	{
		id: ReservationRequestStatus.Declined,
		label: "非承認",
		value: ReservationRequestStatus.Declined,
	},
];
